import { ScenarioType } from '@/constants/scenarioTypes';
import { TemplateType } from '@/constants/templateTypes';

export interface TemplateOption {
  value: string;
  label: string;
}

// 行业选项
export const industryOptions = ['企业服务', '金融', '消费', '科技', '制造'];

// 经典模式模板选项
export const classicTemplateOptions: TemplateOption[] = [
  { value: TemplateType.DEEP, label: '深度纪要' },
  { value: TemplateType.DIALOGUE, label: '对话纪要' },
  { value: TemplateType.KEY_POINTS, label: '要点概述' },
  { value: TemplateType.TASK_ASSIGNMENT, label: '行动计划' },
];

// 场景模式模板选项
export const scenarioTemplateOptions: TemplateOption[] = [
  { value: ScenarioType.PURE_ROADSHOW, label: '纯路演' },
  { value: ScenarioType.ROADSHOW_QA, label: '路演与问答' },
  { value: ScenarioType.DD_INTERVIEW, label: '尽调客户访谈' },
  { value: ScenarioType.POST_INVESTMENT, label: '投后管理' },
];

// 自定义模式模板选项（暂时为空，后续可连接用户自定义模板）
export const customTemplateOptions: TemplateOption[] = [];

export type TemplateMode = 'classic' | 'scenario' | 'custom';

// 根据模式获取模板选项
export const getTemplateOptionsByMode = (mode: TemplateMode): TemplateOption[] => {
  switch (mode) {
    case 'classic':
      return classicTemplateOptions;
    case 'scenario':
      return scenarioTemplateOptions;
    case 'custom':
      return customTemplateOptions;
    default:
      return classicTemplateOptions;
  }
};
